import {  Container } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import { React, useEffect, useState } from "react";
import * as axiosInstance from "../../../services/axiosInstance";
import Helper from "../../../utils/Helper";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../../selectors/auth";
import * as StorageManager from "../../../utils/StorageManager";
import constants from "../../../constants";
import { useHistory } from "react-router";
import clsx from "clsx";
import SetOffHistoryTable from "../components/SetOffHistoryTable";
import * as generalSelectors from "../../../selectors/general";
import SubmittedContractItemModal from "../SetOff/modal/SubmittedContractItemModal";

function SetOffHistory({generalData}) {
  const [page, setPage] = useState(1);
  const [viewData, setViewData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [token, setToken] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submittedContractItemModalVisible, setSubmittedContractItemModalVisible] = useState(false);
  const [targetSubmittedItem, setTargetSubmittedItem] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const contractStatus = generalSelectors.getGeneralOptionsContractStatus(generalData);

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const history = useHistory();
  const search = history?.location?.search;
  const setOffHistoryData = useQuery({
    queryKey: ["set-off-list-data" ,{ page, status, dateFrom, dateTo }],
    queryFn: async () => {
      try {
        const statusQuery = !_.isEmpty(status) ? `&status=${status}` : "";
        const dateQuery =
          !_.isEmpty(dateFrom) && !_.isEmpty(dateTo)
            ? `&created_at_from=${dateFrom}&created_at_to=${dateTo}`
            : "";

        return await axiosInstance.get(`/clientarea/setoff/list?page=${page}${statusQuery}${dateQuery}`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });


  const onClickViewSubmittedItemDetail = (data) => {
    setTargetSubmittedItem(data)
    setSubmittedContractItemModalVisible(true)
  }

  const onCloseSubmittedContractItemModal = () => {
    setTargetSubmittedItem(null)
    setSubmittedContractItemModalVisible(false)

  }

  const onClickDeleteFunction = async (url) => {
    const confirmed = window.confirm("Are you sure you want to cancel this item?");
    if (!confirmed) {
      return;
    }
    setLoading(true);
    try {
      const result = await axiosInstance.del(`${url}`);
      await setOffHistoryData.refetch();
      return result;
    } catch (e) {
    } finally {
      setLoading(false);
      setSubmittedContractItemModalVisible(false);
    }
  };

  return (
      <Container fluid>
        <div className={clsx("custom-card-label-container text-center")}>
          <h2>Setoff History</h2>
        </div>
        <div className={"primary-border-table-border"}>
          <SetOffHistoryTable
              data={setOffHistoryData}
              page={page}
              setPage={setPage}
              onClickViewDetail={onClickViewSubmittedItemDetail}
              viewData={viewData}
              showModal={showModal}
              handleCloseModal={onCloseSubmittedContractItemModal}
              statusFilter={status}
              onChangeStatus={(e) => setStatus(e.target.value)}
              statusOptions={contractStatus}
              dateFrom={dateFrom}
              dateTo={dateTo}
              onChangeDateFrom={(e) => setDateFrom(e.target.value)}
              onChangeDateTo={(e) => setDateTo(e.target.value)}
              onClickDeleteFunction={onClickDeleteFunction}
              loading={loading}
          ></SetOffHistoryTable>
        </div>
        <SubmittedContractItemModal
            // handleCancel={onClickDeleteFunction}
            handleClose={onCloseSubmittedContractItemModal}
            show={submittedContractItemModalVisible}
            data={targetSubmittedItem}
            isHideCancel={true}
            onClickDeleteFunction={onClickDeleteFunction}
            loading={loading}
        ></SubmittedContractItemModal>
      </Container>
  );
}

export default SetOffHistory;
